import { createReducer, on } from '@ngrx/store';
import { cloneDeep, omit } from 'lodash';

import { SearchResult } from '@core/api';
import { ActionUIState, initActions } from '@core/store';
import { Extent } from '@shared/open-layers';

import { leaveMap } from '../actions/map-page.actions';
import * as searchActions from '../actions/search.actions';

export const featureKey = 'search';

export interface SearchCacheItem {
  phrase: string;
  type: string;
  result?: SearchResult;
  error?: string;
}

export interface SearchState extends ActionUIState {
  phrase: string;
  results: SearchCacheItem[];
  selectedLocation?: GeoJSON.Feature[] | Extent;
}

export const initialState: SearchState = {
  status: 'INIT',
  phrase: '',
  results: [],
};

export const reducer = createReducer<SearchState>(
  cloneDeep(initialState),
  on(initActions.appCleanup, leaveMap, () => cloneDeep(initialState)),

  on(searchActions.search, (state, { phrase }) => ({
    ...omit(state, ['selectedLocation']),
    phrase,
    status: 'LOADING',
  })),
  on(searchActions.searchCompleted, (state, { results }) => {
    const typesUpdated = [...new Set(results.map((item) => item.type))];
    const phrase = results[0]?.phrase ?? state.phrase;

    const remaining = state.results.filter((item) => !(item.phrase === phrase && typesUpdated.includes(item.type)));

    return {
      ...state,
      status: 'READY',
      results: [...remaining, ...results],
    };
  }),
  on(searchActions.clear, (state) => ({
    ...state,
    phrase: initialState.phrase,
    status: initialState.status,
  })),

  on(searchActions.renderLocation, (state, { location }) => ({
    ...state,
    selectedLocation: location,
  }))
);
